// extracted by mini-css-extract-plugin
export default {"parkingSpaces":"styles_parkingSpaces__-68Za","holder":"styles_holder__LAXrK","count":"styles_count__gWtV4"};